// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__2EJRB","block":"Tooltip_block__2UyMf","fullWidth":"Tooltip_fullWidth__1jH_P","fullHeight":"Tooltip_fullHeight__1kx6L"};